import Icon from '@mui/material/Icon'
export const icons = [
  { name: 'Home', icon: 'home' },
  { name: 'Car', icon: 'directions_car' },
  { name: 'Bicycle', icon: 'directions_bike' },
  { name: 'Cake', icon: 'cake' },
  { name: 'Soccer Ball', icon: 'sports_soccer' },
  { name: 'Pet', icon: 'pets' },
  { name: 'Park', icon: 'park' },
  { name: 'Beach', icon: 'beach_access' },
  { name: 'Airplane', icon: 'flight' },
  { name: 'Bar', icon: 'local_bar' },
  { name: 'Cafe', icon: 'local_cafe' },
  { name: 'Restaurant', icon: 'restaurant' },
  { name: 'Ice Cream', icon: 'icecream' },
  { name: 'Swimming Pool', icon: 'pool' },
  { name: 'Music Note', icon: 'music_note' },
  { name: 'Movie', icon: 'movie' },
  { name: 'Basketball', icon: 'sports_basketball' },
  { name: 'Video Game', icon: 'sports_esports' },
  { name: 'Casino', icon: 'casino' },
  { name: 'Nightlife', icon: 'nightlife' },
  { name: 'Golf', icon: 'golf_course' },
  { name: 'Skateboarding', icon: 'skateboarding' },
  { name: 'Snowboarding', icon: 'snowboarding' },
  { name: 'Kayaking', icon: 'kayaking' },
  { name: 'Surfing', icon: 'surfing' },
  { name: 'Friends', icon: 'diversity_3' },
  { name: 'Child Care', icon: 'child_care' },
  { name: 'Child Friendly', icon: 'child_friendly' },
  { name: 'Toys', icon: 'toys' },
  { name: 'Microphone', icon: 'mic' },
  { name: 'Camera', icon: 'camera_alt' },
  { name: 'Pizza', icon: 'local_pizza' },
  { name: 'Fast Food', icon: 'fastfood' },
  { name: 'Happy Face', icon: 'emoji_emotions' },
  { name: 'Nature', icon: 'emoji_nature' },
  { name: 'People', icon: 'emoji_people' },
  { name: 'Food & Drink', icon: 'emoji_food_beverage' },
  { name: 'Transportation', icon: 'emoji_transportation' },
  { name: 'Objects', icon: 'emoji_objects' },
  { name: 'Flowers', icon: 'local_florist' },
  { name: 'Storefront', icon: 'storefront' },
  { name: 'Shopping Cart', icon: 'shopping_cart' },
  { name: 'Shopping Bag', icon: 'shopping_bag' },
  { name: 'Bakery', icon: 'bakery_dining' },
  { name: 'Brunch', icon: 'brunch_dining' },
  { name: 'Kebab', icon: 'kebab_dining' },
  { name: 'Liquor', icon: 'liquor' },
  { name: 'Ramen', icon: 'ramen_dining' },
  { name: 'Dinner', icon: 'dinner_dining' },
  { name: 'Breakfast', icon: 'breakfast_dining' },
  { name: 'Ice Skating', icon: 'ice_skating' },
  { name: 'Hiking', icon: 'hiking' },
  { name: 'Rowing', icon: 'rowing' },
  { name: 'Running', icon: 'directions_run' },
  { name: 'Walking', icon: 'directions_walk' },
  { name: 'Roller Skating', icon: 'roller_skating' },
  { name: 'Sailing', icon: 'sailing' },
  { name: 'Train', icon: 'train' },
  { name: 'Subway', icon: 'subway' },
  { name: 'Bus', icon: 'directions_bus' },
  { name: 'Taxi', icon: 'local_taxi' },
  { name: 'Hotel', icon: 'hotel' },
  { name: 'Museum', icon: 'museum' },
  { name: 'Art', icon: 'color_lens' },
  { name: 'Balloon', icon: 'celebration' },
  { name: 'Star', icon: 'star' },
  { name: 'Fireplace', icon: 'fireplace' },
  { name: 'Castle', icon: 'castle' },
  { name: 'Tree', icon: 'nature' },
  { name: 'Tent', icon: 'carpenter' },
  { name: 'Mountain', icon: 'terrain' },
  { name: 'Sun', icon: 'wb_sunny' },
  { name: 'Moon', icon: 'dark_mode' },
  { name: 'Rainbow', icon: 'looks' },
  { name: 'Heart', icon: 'favorite' },
  { name: 'Gift', icon: 'card_giftcard' },
  { name: 'Celebration', icon: 'emoji_events' },
  { name: 'Fireworks', icon: 'local_fire_department' },
  { name: 'Lightbulb', icon: 'lightbulb' },
  { name: 'Books', icon: 'menu_book' },
  { name: 'School', icon: 'school' },
  { name: 'Graduation', icon: 'emoji_symbols' },
  { name: 'Laptop', icon: 'laptop' },
  { name: 'Tablet', icon: 'tablet_mac' },
  { name: 'Phone', icon: 'smartphone' },
  { name: 'Headphones', icon: 'headphones' },
  { name: 'Speaker', icon: 'speaker' },
  { name: 'TV', icon: 'tv' },
  { name: 'Board Game', icon: 'extension' },
  { name: 'Magic Wand', icon: 'auto_fix_high' },
  { name: 'Wand', icon: 'auto_awesome' },
  { name: 'Rocket', icon: 'rocket_launch' },
  { name: 'Planet', icon: 'public' },
  { name: 'Alien', icon: 'adb' },
  { name: 'Robot', icon: 'smart_toy' }
]
export function getIcon (iconName, addMargin = true) {
  return <Icon sx={{ verticalAlign: 'bottom', mr: addMargin ? 1 : 0 }}>{iconName}</Icon>
}
